import { render } from "./fiche.vue?vue&type=template&id=420fef52&scoped=true"
import script from "./fiche.vue?vue&type=script&lang=js"
export * from "./fiche.vue?vue&type=script&lang=js"

import "./fiche.vue?vue&type=style&index=0&id=420fef52&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/mFokeeiy/0/bpavone/detect-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420fef52"]])

export default __exports__